const CardTypeRef = Object.freeze({
    AMEX: 'amex',
    DELTA: 'delta',
    DINERS: 'diners',
    DISCOVER: 'discover',
    JCB: 'jcb',
    LASER: 'laser',
    MAESTRO: 'maestro',
    MASTERCARD: 'mastercard',
    SOLO: 'solo',
    UNIONPAY: 'unionpay',
    VISA: 'visa',
    VISA_CREDIT: 'visa-credit',
    VISA_DEBIT: 'visa-debit',
    VISA_ELECTRON: 'visa-electron',
});

module.exports = CardTypeRef;
